/*global define, angular, dna, console*/
define('core/services/ConfigurationService',[
    'angular',
    'utils/cookies'
], function (angular, Cookies) {
    'use strict';
    angular.module('dnaApp').service('ConfigurationService', ['$http', '$q', '$interval', function ($http, $q, $interval) {

        var DEFAULT_REFRESH_TIMING = 1800000,  // 30 Minutes
            MAX_ERROR_REFRESH_TIMING = 14400000, // 4 Hour MAX
            lastPullTime = 0; // Start at zero so we get an initial pull.

        // DEFAULT CONFIGURATION VALUES
        var configSettings = {
            configRefreshTiming: DEFAULT_REFRESH_TIMING,
            enableMatchingOptOut: dna.app.enableMatchingOptOut || false
        };

        function overrideConfigSettings() {
            // override config settings with value from cookie
            if (Cookies.find('dnaConfigSettings')) {
                try {
                    var overConfig = JSON.parse(Cookies.find('dnaConfigSettings'));
                    angular.extend(configSettings, overConfig);
                    console.log('configSettings overridden with', overConfig);
                } catch (e) {}
            }
        }
        overrideConfigSettings();

        function _errorPullingSettings() {
            // Double error timeout each time to help servers to recover.
            configSettings.configRefreshTiming = configSettings.configRefreshTiming || DEFAULT_REFRESH_TIMING;

            var errorRefreshTiming = configSettings.configRefreshTiming * 2;
            errorRefreshTiming = errorRefreshTiming < MAX_ERROR_REFRESH_TIMING ? errorRefreshTiming : MAX_ERROR_REFRESH_TIMING;
            configSettings.configRefreshTiming = errorRefreshTiming;
        }

        /**
         * Pulls the latest configuration settings from the ConfigurationService.
         * Deferred should ALWAYS resolve, either to the defaults or the updated settings from the service.
         */
        function _pullConfigurationSettings(deferred) {
            var url = '/util/configurationSettings';

            $http.get(url).success(function(data, status, headers, config) {
                for (var i=0; i < data.length; i++) {
                    var featureName = data[i].featureName;
                    var setting = data[i].setting;
                    if (featureName && setting) {
                        if (!isNaN(setting) && isFinite(setting) && setting.trim() !== '') {
                            setting = Number(setting);
                        } else if (setting === 'true' || setting === 'false') {
                            setting = (setting === 'true');
                        }
                        configSettings[featureName] = setting;
                    }
                }

                lastPullTime = new Date().getTime();
                overrideConfigSettings();
                deferred.resolve(configSettings);

            }).error(function(data, status, headers, config) {
                _errorPullingSettings();
                lastPullTime = new Date().getTime();
                deferred.reject();
            });
        }

        /**
         * @class ConfigurationService
         * @desc Service used for retrieving and saving a user's preferences.
         */
        return {
            // Pull settings the first time and then only if a certain amount of time has passed.
            getConfigurationSettings: function() {
                this.loadingDeferrer = $q.defer();

                // Pull settings on first time (lastPullTime is 0) or if we have passed the refresh time.
                var timeFromLastPull = new Date().getTime() - lastPullTime;
                var refreshTiming = configSettings.configRefreshTiming || DEFAULT_REFRESH_TIMING;

                // Only get new settings if it's been long enough, otherwise return the current settings.
                if (timeFromLastPull > refreshTiming) {
                    // Call to change settings
                    // console.log('ConfigurationService - Update Configuration Settings');
                    _pullConfigurationSettings(this.loadingDeferrer);
                } else {
                    // Don't call to change settings
                    // console.log('ConfigurationService - Don\'t Change Configuration Settings');
                    this.loadingDeferrer.resolve(configSettings);
                }
                return this.loadingDeferrer.promise;
            },

            getCurrentConfigSettings: function() {
                if (this.loadingDeferrer) {
                    return this.loadingDeferrer.promise;
                } else {
                    return this.getConfigurationSettings();
                }
            },

            configSettings: configSettings
        };
    }]);
});

